import { Form } from 'formik';
import PropTypes from 'prop-types';
import PolicyModal from './PolicyModal';
import DevicePolicyDescription from './DevicePoicyDescription';
import FormSwitchButton from '../FormSwitchButton';
import DevicePolicyList from './DevicePolicyList';
import { useDevicePolicyHandlers } from './useDevicePolicyHandlers';

export const DevicePolicyEnum = {
  trusted: 'TRUSTED',
  untrusted: 'UNTRUSTED',
};

function DevicePolicy({ tenant }) {
  const {
    handleRemoveClicked,
    handleEditClicked,
    handleHide,
    handleAddClicked,
    handleAddComplete,
    policies,
    showAdd,
    editPolicy,
  } = useDevicePolicyHandlers();

  if (!tenant) {
    return null;
  }

  return (
    <>
      <DevicePolicyDescription tenantKey={tenant.key} />
      <hr />
      <Form style={{ width: '30rem' }}>
        <div style={{ marginBottom: '2em' }}>
          <FormSwitchButton
            name="defaultDevicePolicy"
            label="Trust incoming calls from unknown devices"
          />
        </div>
        <DevicePolicyList
          policies={policies}
          onAdd={handleAddClicked}
          onEdit={handleEditClicked}
          onRemove={handleRemoveClicked}
        />
        <br />
      </Form>

      <PolicyModal
        show={showAdd}
        onHide={handleHide}
        onComplete={handleAddComplete}
        existingPolicies={policies}
        currentPolicy={editPolicy}
      />
    </>
  );
}

DevicePolicy.propTypes = { tenant: PropTypes.object };

export default DevicePolicy;
